import { ControlBar, Container, PlaybackTimeLabel, PlaybackTimeLabelMode, SeekBar, SeekBarLabel, Spacer } from 'bitmovin-player-ui';
import { createForwardButton, createRewindButton, createAirPlayToggleButton, createCastToggleButton, createFullscreenToggleButton, createPictureInPictureToggleButton, createPlaybackToggleButton, createSettingsButton, createVolumeToggleButton } from './buttons';
import { createSettingsPanel } from '../settingspanel';
export function createControlBar(player) {
    const rewindButton = createRewindButton(player);
    const forwardButton = createForwardButton(player);
    const settingsPanel = createSettingsPanel(player);
    return new ControlBar({
        components: [
            new Container({
                components: [
                    new PlaybackTimeLabel({
                        timeLabelMode: PlaybackTimeLabelMode.CurrentTime,
                        hideInLivePlayback: true,
                        cssClasses: ['current-time']
                    }),
                    new SeekBar({ label: new SeekBarLabel() }),
                    new PlaybackTimeLabel({
                        timeLabelMode: PlaybackTimeLabelMode.TotalTime,
                        cssClasses: ['total-time']
                    })
                ],
                cssClasses: ['controlbar-top']
            }),
            new Container({
                components: [
                    createPlaybackToggleButton(),
                    createVolumeToggleButton(player),
                    rewindButton,
                    forwardButton,
                    new Spacer(),
                    createPictureInPictureToggleButton(player),
                    createAirPlayToggleButton(),
                    createCastToggleButton(),
                    createSettingsButton(settingsPanel),
                    settingsPanel,
                    createFullscreenToggleButton(player)
                ],
                cssClasses: ['controlbar-bottom']
            })
        ]
    });
}
